import { gyRegister } from '@/api/common/index.js'

export function initPlugin () {
  return new Promise(async (resolve, reject) => {
    const res = await gyRegister()
    if (!res.msg) return reject(res)
    window.initGeetest({
      product: 'bind',
      gt: res.msg.gt,
      challenge: res.msg.challenge,
      offline: !res.msg.success,
      new_captcha: true
    }, function (captchaObj) {
      resolve(captchaObj)
    })
  })
}
